
    var css = require("!!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].rules[2]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].rules[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[2].rules[4]!./layout.scss");
    var insertCss = require("!../../node_modules/isomorphic-style-loader/insertCss.js");
    var content = typeof css === 'string' ? [[module.id, css, '']] : css;

    exports = module.exports = css.locals || {};
    exports._getContent = function() { return content; };
    exports._getCss = function() { return '' + css; };
    exports._insertCss = function(options) { return insertCss(content, options) };

    
  